import { render, staticRenderFns } from "./SelectTheme.vue?vue&type=template&id=a35cb890&scoped=true&"
import script from "./SelectTheme.vue?vue&type=script&lang=js&"
export * from "./SelectTheme.vue?vue&type=script&lang=js&"
import style0 from "./SelectTheme.vue?vue&type=style&index=0&id=a35cb890&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35cb890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VListGroup,VListItemContent,VListItemTitle})
